// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"4aa1f262","235":"2df60915","979":"ec32bf7c"}[chunkId] + ".css";
};